<template>
    <div class="fw-service">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div>
            <img src="../../assets/cjmb.png" class="cjimg">
            <div class="fw-userinfo">
                <div class="mmin">
                    <div class="userinfo">
                        <span>{{member.memberName}}</span>
                        <span v-if="member.sex == 0">未知</span>
                        <span v-if="member.sex == 1">男</span>
                        <span v-if="member.sex == 2">女</span>
                        <span style="font-size: 11px;line-height: 18px">({{member.phone}})</span>
                    </div>
                    <div style="display:flex;flex-direction: row;align-items: center;height: 30px">
                          <span style="font-size: 13px;margin-right: 5px" v-if="member.deptName">{{member.deptName}}</span>
                      <div class="ui-jb">
                          <img src="../../assets/huizhang.png" class="ui-jb-img">
                          <span style="padding-left: 8px">{{member.lvName==null?'未开通':member.lvName}}</span>
                      </div>
                  </div>
                </div>
            </div>
        </div>
        <div>
            <van-tabs v-model="active" @click="onClick">
                <van-tab title="服务中心" >
                    <FwCenter ref="fwCenter" :memberId="memberId"/>
                </van-tab>
                <van-tab title="基本信息" >
                    <MemberInfo ref="fwCenter" :memberId="memberId"/>
                </van-tab>
                <van-tab title="会员权益" />
                <van-tab title="标签中心" />
                <van-tab title="客户提醒" />
            </van-tabs>
        </div>
    </div>
</template>

<script>

    import {getCookie} from "../../utils/auth";
    import FwCenter from "./center/center";
    import MemberInfo from "./memberinfo/memberinfo";

    export default {
        components: {FwCenter,MemberInfo},
        data() {
            return {
                title:'客户服务',
                deptId:'',
                token:'',
                active:0,
                memberId:'',
                member:{},

                bkShow:false,
                xkShow:false,
            };
        },
        async created() {
            this.memberId=this.$route.query.memberId
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.getMemberInfo()
        },
        methods: {
            onClick(){
            },
            toTcs(){
                this.$router.push('/myMdTc?memberId='+this.memberId)
            },
            toXfs(){
                this.$router.push('/myMdCmp?memberId='+this.memberId)
            },
            async getMemberInfo() {
                let data = {
                    memberId: this.memberId,
                }
                let res = await this.$get("/fw/getFwMember", data)
                this.member = res.member
            },
            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-service {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 47px;
        background-color: #F1F1F1;
    }
    .cjimg{

    }
    .fw-userinfo{
        display: flex;
        flex-direction: row;
        position: absolute;
        top:75px;
        color: #ffffff;
        padding-left: 28px;
        padding-top: 5px;
    }
    .u-img{
        width: 50px;
        height: 50px;
    }
    .mmin{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 4px 0;
        margin-left: 12px
    }
    .userinfo{
        font-size: 15px;
        font-weight: bold;
        display: flex;
        flex-direction: row;
    }
    .userinfo span{
        margin-right: 10px;
    }

    .ui-jb{
        background-color: #C18DFC;
        font-size: 10px;
        padding: 0 20px 0 5px;
        border-radius: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #FFFFFF;
    }
    .ui-jb-img{
        width: 23px;
        height: 13px;
    }

</style>